module.exports = (__webpack_require__(8))(28);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/widgets/PaginateWidget.js from dll-reference girder_lib
// module id = 965
// module chunks = 0